import gql from 'graphql-tag';

export const CAMPAIGN_WITH_DOMAINS_QUERY = gql`
  query CampaignWithDomainsQuery($id: ID!) {
    campaign(id: $id) {
      id
      name
      domains {
        id
        address
      }
      snowplowAppIds
    }
  }
`;
